// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3pqej","fullwidth":"styles_fullwidth__ybuw0"};